var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isLoaded)?_c('div',[(!_setup.isError)?_c(_setup.ConsentPromotion,{attrs:{"promotion-info":_setup.promotionInfo}}):_c(_setup.Error,{attrs:{"error-title":_setup.ERROR_MSG_TITLE_INVALID_USER,"error-text":_setup.ERROR_MSG_TEXT_INVALID_USER}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }